module.exports = __webpack_public_path__ + "img/loading_dark.0b9386fb.gif";